<div class="wrapper">
  <h2>Рука на пульсе. Графики</h2>
  <div class="charts">
    <div class="chart">
      <h3 class="chart-header"> Чаты </h3>
      <app-bar-chart
        [pulseReportChartData]="pulseReportChartData"
      />
    </div>
<!--    <div class="chart">-->
<!--      <h3 class="chart-header"> Бюджет </h3>-->
<!--      <app-bar-chart/>-->
<!--    </div>-->
<!--    <div class="chart">-->
<!--      <h3 class="chart-header"> Согласования </h3>-->
<!--      <app-bar-chart/>-->
<!--    </div>-->
  </div>
</div>

